import { Text, View } from 'react-native'
import { colors } from '@chillout/core'

export type AdminPillTone = 'staff' | 'manager' | 'active' | 'inactive' | 'pending'

interface AdminPillProps {
  label: string
  tone: AdminPillTone
}

export function AdminPill({ label, tone }: AdminPillProps) {
  const widthClassName = tone === 'staff' || tone === 'manager' ? 'w-[76px]' : 'w-[74px]'
  const roleColors = tone === 'manager' || tone === 'staff' ? colors.role[tone] : undefined

  if (roleColors) {
    return (
      <View className={`${widthClassName} items-center rounded-md px-2 py-1`} style={{ backgroundColor: roleColors.bg }}>
        <Text className="text-xs font-medium" style={{ color: roleColors.text }}>{label}</Text>
      </View>
    )
  }

  const toneClass = tone === 'active'
    ? { bg: 'bg-success/10', text: 'text-success' }
    : tone === 'pending'
      ? { bg: 'bg-warning/10', text: 'text-warning' }
      : { bg: 'bg-border/60', text: 'text-secondary' }

  return (
    <View className={`${widthClassName} items-center rounded-md px-2 py-1 ${toneClass.bg}`}>
      <Text className={`text-xs font-medium ${toneClass.text}`}>{label}</Text>
    </View>
  )
}